import { Carousel } from '../../views/ts/components/Carousel';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { MenuButton } from '../twig/components/MenuButton';
import { Cursor } from '../twig/components/Cursor';
import { ClientList } from '../twig/modules/client_list';
import { Caption } from '../twig/components/Caption';
import { Appear } from '../twig/components/Appear';
import { Titles } from '../twig/modules/titles';
import { List } from '../twig/modules/list';
(new Carousel()).init();
/*(new Collapse()).init();
(new Dropdown()).init();*/
(new LazyLoader()).init();
/*(new ScrollSpy()).init();*/
(new ClientList()).init();
(new MenuButton()).init();
(new Cursor()).init();
(new Caption()).init();
(new Appear()).init();
(new Titles()).init();
(new List()).init();
